import { FormRadioGroup } from "@pharmupp/p3-front-commons"
import { userTitleEnum } from "../../../../../../referential"
import { fields } from "../../GeneralInfos.fields"
import { isTitleRequired } from "../../GeneralInfos.rg"
import { useGetUserTypeField } from "../useGetUserTypeField"

const titleRadioValues: { label: string; value: string }[] = Object.entries(
  userTitleEnum,
).map(([key, value]) => ({
  label: value.label,
  value: key,
}))

export const ConditionalTitleField = () => {
  const type = useGetUserTypeField()

  const required = isTitleRequired(type)

  return (
    <FormRadioGroup
      name={fields.title}
      radios={titleRadioValues}
      required={required}
      row
    />
  )
}
